/* eslint no-extend-native: ["error", { "exceptions": ["Array"] }] */
import remove from 'lodash/remove'
// import intersect from 'fast_array_intersect'
// import setting from '../../assets/setting'
import setting from 'crossasia-itr-fulltextsearch-setting'
// import { debounce } from 'debounce'
// import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'

const _ = {remove: remove}
const TimSort = require('timsort')
const IdCompare = function (a, b) {
  return b[1] - a[1]
}
const state = {
  jobs: [],
  totalNoOfBooks: {},
  totalNoOfPages: {},
  noOfBooks: {},
  noOfPages: {},
  bookIds: {},
  allBooksId: [],
  noOfFetch: 0,
  selectedBook: null,
  page: -1,
  facets: {},
  selectedFacets: {},
  filteredBooks: {},
  validBooks: [],
  setting: setting,
  terms: []
//   checkoutStatus: null
}

// getters
const getters = {
  getSearchTerms: (state) => {
    return state.terms
  },
  getJobs: (state) => (id) => {
    // let collections = Object.values(state.noOfBooks) || []
    // return collections.reduce((acc, x) => acc + x, 0)
    return state.jobs.indexOf(id)
  },
  getAllNoOfBooks: (state, getters) => {
    // let collections = Object.values(state.noOfBooks) || []
    // return collections.reduce((acc, x) => acc + x, 0)
    // return getters.getValidBooks.length
    // console.table(state.totalNoOfBooks)
    return Object.entries(state.totalNoOfBooks).reduce((acc, x) => acc + (x[1] || 0), 0) || 0
  },
  getAllNoOfPages: (state, getters) => {
    // let collections = Object.values(state.noOfPages) || []
    // return collections.reduce((acc, x) => acc + x, 0)
    // return getters.getValidBooks.reduce((acc, x) => acc + x[1], 0)
    // console.table(state.totalNoOfPages)
    return Object.entries(state.totalNoOfPages).reduce((acc, x) => acc + x[1], 0)
  },
  getTotalNoOfBooks: (state) => (id) => {
    return state.totalNoOfBooks[id]
  },
  getTotalNoOfPages: (state) => (id) => {
    return state.totalNoOfPages[id]
  },
  getNoOfBooks: (state) => (id) => {
    return state.noOfBooks[id]
  },
  getNoOfPages: (state) => (id) => {
    return state.noOfPages[id]
  },
  getSelectedBook: (state) => {
    return state.selectedBook
  },
  getPage: (state) => {
    return state.page
  },
  getFacet: (state) => (facetName) => {
    return state.facets[facetName]
  },
  getSelectedFacets: (state) => {
    return state.selectedFacets
  },
  getValidBooks: (state) => {
    return state.validBooks
  }
  // getAllBooksId: (state) => {
  //   let filteredBooks = state.filteredBooks
  //   if (filteredBooks.length > 0) {
  //     return state.allBooksId.filter(x => filteredBooks.indexOf([x[0], x[2]].join('|')) > -1)
  //   } else {
  //     return state.allBooksId
  //   }
  // }
//   cartTotalPrice: (state, getters) => {
//     return getters.cartProducts.reduce((total, product) => {
//       return total + product.price * product.quantity
//     }, 0)
//   }
}

// actions
const actions = {
  addJob ({commit, state}, updates) {
    commit('addJob', updates)
  },
  removeJob ({commit, state}, updates) {
    commit('removeJob', updates)
  },
  setPage ({commit, state}, updates) {
    commit('setPage', updates)
  },
  setFacet ({commit, state}, updates) {
    commit('setFacet', updates)
  },
  setNoOfFetch ({commit, state}, updates) {
    commit('setNoOfFetch', updates)
  },
  setSelectedBook ({commit, state}, updates) {
    commit('setSelectedBook', updates)
  },
  reset ({commit, state}) {
    commit('reset')
  },
  filterReset ({commit, state}) {
    commit('filterReset')
  },
//   appendRecords ({commit, state}, records) {
//     commit('appendRecords', records)
//   },
//   concatRecords ({commit, state}, records) {
//     commit('concatRecords', records)
//   },
//   sortRecords ({commit, state}, searchByHits) {
//     commit('sortRecords', searchByHits)
//   },
  updateNoOfBooks ({commit, state}, updates) {
    commit('updateNoOfBooks', updates)
  },
  updateNoOfPages ({commit, state}, updates) {
    commit('updateNoOfPages', updates)
  },
  addNoOfBooks ({commit, state}, updates) {
    commit('addNoOfBooks', updates)
  },
  addNoOfPages ({commit, state}, updates) {
    commit('addNoOfPages', updates)
  },
  addBookIds  ({commit, state}, updates) {
    commit('addBookIds', updates)
    commit('updateValidBooks', updates)
  },
  fetchBookIsDone ({commit, state}, update) {
    commit('fetchBookIsDone')
    if (state.noOfFetch === 0) {
      commit('updateValidBooks')
      // console.log('fire updateValidBooks')
    }
    if (update.always === true) {
      commit('updateValidBooks')
    }
    commit('setPage', {page: 0})
  },
  selectFacetItem ({commit, state}, facet) {
    // console.log('selectFacetItem')
    commit('selectFacetItem', facet)
  },
  removeSelectedFacet ({commit, state}, facet) {
    // console.log('removeSelectedFacet')
    commit('setPage', {page: -1})
    commit('removeSelectedFacet', facet)
    commit('setPage', {page: 0})
  },
  removeFilteredBooks ({commit, state}) {
    // console.log('removeSelectedFacet')
    commit('setPage', {page: -1})
    commit('removeFilteredBooks')
    commit('setPage', {page: 0})
    commit('updateValidBooks', state)
  },
  addFilteredBooks ({commit, state}, facet) {
    // console.log('removeSelectedFacet')
    commit('addFilteredBooks', facet)
    // commit('updateValidBooks', facet)
  },
  updateValidBooks ({commit, state}, facet) {
    // console.log('removeSelectedFacet')
    commit('setPage', {page: -1})
    commit('updateValidBooks', facet)
    commit('setPage', {page: 0})
  },
  setTerms ({commit, state}, update) {
    commit('setTerms', update)
  }
//   addSelectedRecordsPages ({commit, state}, cache) {
//     commit('addSelectedRecordsPages', cache)
//   }
}

// mutations
const mutations = {
  reset (state) {
    Vue.set(state, 'totalNoOfBooks', {})
    Vue.set(state, 'totalNoOfPages', {})
    Vue.set(state, 'jobs', [])
    Vue.set(state, 'noOfBooks', {})
    Vue.set(state, 'noOfPages', {})
    Vue.set(state, 'bookIds', {})
    Vue.set(state, 'allBooksId', [])
    Vue.set(state, 'noOfFetch', 0)
    Vue.set(state, 'selectedBook', null)
    Vue.set(state, 'page', -1)
    Vue.set(state, 'facets', {})
    Vue.set(state, 'selectedFacets', {})
    Vue.set(state, 'filteredBooks', {})
    // console.log('reset')
  },
  filterReset (state) {
    Vue.set(state, 'totalNoOfBooks', {})
    Vue.set(state, 'totalNoOfPages', {})
    Vue.set(state, 'jobs', [])
    Vue.set(state, 'noOfBooks', {})
    Vue.set(state, 'noOfPages', {})
    Vue.set(state, 'bookIds', {})
    Vue.set(state, 'allBooksId', [])
    Vue.set(state, 'noOfFetch', 0)
    Vue.set(state, 'selectedBook', null)
    Vue.set(state, 'page', -1)
    Vue.set(state, 'facets', {})
        // Vue.set(state, 'selectedFacets', {})
    Vue.set(state, 'filteredBooks', {})
    // Vue.set(state, 'selectedFacets', {})
  },
  addJob (state, update) {
    state.jobs.push(update)
    // Vue.set(state, 'jobs', state.jobs.push(update))
  },
  removeJob (state, update) {
    state.jobs.splice(state.jobs.indexOf(update), 1)
    // Vue.set(state, 'jobs', state.jobs.splice(state.jobs.indexOf(update), 1))
  },
  setPage (state, updates) {
    Vue.set(state, 'page', updates.page)
  },
  setFacet (state, updates) {
    // console.log(state.facets, updates)
    // state.facets[updates.facet] = updates.value
    Vue.set(state.facets, updates.facet, updates.value)
    // Vue.set(state, 'facets', state.facets)
    // console.log('facet changed in store')
  },
  setTerms (state, updates) {
    Vue.set(state, 'terms', updates.terms)
  },
  setSelectedBook (state, updates) {
    Vue.set(state, 'selectedBook', updates.selectedBook)
  },
  setNoOfFetch (state, updates) {
    // console.log(state.noOfFetch)
    Vue.set(state, 'noOfFetch', updates.noOfFetch)
  },
  addBookIds (state, updates) {
    // console.log(updates.bookIds)
    let _tmp = state.bookIds[updates.id] || {}
    let booksIds = updates.bookIds.map(x => [x[0], x[1], updates.id])
    updates.bookIds.reduce((acc, x) => {
      _tmp[x[0]] = x[1]
    }, _tmp)
    // _tmp = _tmp.concat(booksIds)
    // TimSort.sort(_tmp, IdCompare)
    // TimSort.sort(updates.bookIds, IdCompare)
    // console.log(updates.bookIds)
    Vue.set(state.bookIds, updates.id, _tmp)
    Vue.set(state, 'bookIds', state.bookIds)
    // state.allBooksId = state.allBooksId.concat(updates.bookIds.map(x => x[2] = updates.id; return x }))
    state.allBooksId = state.allBooksId.concat(booksIds)
    TimSort.sort(state.allBooksId, IdCompare)
  },
  fetchBookIsDone (state) {
    Vue.set(state, 'noOfFetch', state.noOfFetch - 1)
    if (state.noOfFetch === 0) {
      Vue.set(state, 'page', 0)
    }
  },
  updateNoOfBooks (state, updates) {
    Vue.set(state.totalNoOfBooks, updates.id, updates.noOfBooks)
    Vue.set(state, 'totalNoOfBooks', state.totalNoOfBooks)
  },
  updateNoOfPages (state, updates) {
    Vue.set(state.totalNoOfPages, updates.id, updates.noOfPages)
    Vue.set(state, 'totalNoOfPages', state.totalNoOfPages)
  },
  addNoOfBooks (state, updates) {
    let noOfBooks = state.noOfBooks[updates.id] || 0
    Vue.set(state.noOfBooks, updates.id, noOfBooks + updates.noOfBooks)
    Vue.set(state, 'noOfBooks', state.noOfBooks)
  },
  addNoOfPages (state, updates) {
    let noOfPages = state.noOfPages[updates.id] || 0
    Vue.set(state.noOfPages, updates.id, noOfPages + updates.noOfPages)
    Vue.set(state, 'noOfPages', state.noOfPages)
    // console.log(state.noOfBooks)
    // updates.forEach(function (updateResult) {
    //   let _index = -1
    //   let target = state.records.filter(function (result, index) {
    //     let found = result.id === updateResult.id && result.source === updateResult.source
    //     if (found) {
    //       // console.log([result.id, updateResult.id, result.source, .source].join('\t'))
    //       _index = index
    //     }
    //     return found
    //   })
    //   if (target.length === 1) {
    //     // console.log(_index)
    //     // console.log(target)
    //     if (target) {
    //       target[0]['title'] = updateResult.title
    //       target[0]['creator'] = updateResult.creator
    //       target[0]['url'] = updateResult.url
    //       target[0]['opacurl'] = updateResult.opacurl
    //       target[0]['databaseurl'] = updateResult.databaseurl
    //       target[0]['date'] = updateResult.date
    //       target[0]['collection'] = updateResult.collection
    //       target[0]['edition'] = updateResult.edition
    //       target[0]['updated'] = true
    //       // console.log(target)
    //       // console.log(state.records[_index])
    //       Vue.set(state.records, _index, target[0])
    //     }
    //   } else {
    //   }
    // })
  },
  selectFacetItem (state, facet) {
    Vue.set(state.selectedFacets, facet.name, facet.item)
    // console.log(state.selectedFacets)
  },
  removeSelectedFacet (state, facet) {
    // console.log('removeSelectedFacetMul')
    const _facet = facet.name
    const item = facet.item
    // console.log(state.selectedFacets[_facet].filter(x => ))
    // console.log(JSON.stringify(state.selectedFacets))
    let items = _.remove(state.selectedFacets[_facet], x => x.facet !== item.facet)
    // console.log(items)
    // console.log(JSON.stringify(state.selectedFacets))
    if (items.length === 0) {
      delete state.selectedFacets[_facet]
      // console.log(JSON.stringify(state.selectedFacets))
      Vue.set(state, 'selectedFacets', state.selectedFacets)
    } else {
      Vue.set(state.selectedFacets, _facet, items)
    }
    // console.log(JSON.stringify(state.selectedFacets))
    // console.log(state.selectedFacets)
  },
  removeFilteredBooks (state) {
    // console.log('removeSelectedFacetMul')
    Vue.set(state, 'filteredBooks', {})
  },
  addFilteredBooks (state, updates) {
    // let filteredBooks = updates.books.map(x => { return [x[0], updates.id].join('|') })
    // Vue.set(state, 'filteredBooks', state.filteredBooks.concat(filteredBooks))
    let tmp = state.filteredBooks[updates.id] || []
    // console.log(updates)
    tmp = tmp.concat(updates.books)
    Vue.set(state.filteredBooks, updates.id, tmp)
    Vue.set(state, 'filteredBooks', state.filteredBooks)
    // Vue.set(state, 'noOfBooks', state.noOfBooks)
  },
  updateValidBooks (state) {
    // let filteredBooks = [].concat(state.filteredBooks) || []
    // console.log(filteredBooks)
    // filteredBooks = ArraySet(filteredBooks)
    // state.allBooksId = state.allBooksId.concat(updates.bookIds.map(x => x[2] = updates.id; return x }))
    // state.allBooksId = state.allBooksId.concat(updates.bookIds.map(x => [x[0], x[1], updates.id, `${x[0]}|${updates.id}`]))
    // TimSort.sort(state.allBooksId, IdCompare)
    let filterBooksEntries = Object.entries(state.filteredBooks).filter(x => x[1].length > 0)
    if (filterBooksEntries.length > 0) {
      // console.log(filterBooksEntries)
      let bookIds = state.bookIds
      let tmp = filterBooksEntries.reduce((acc, x) => {
        let source = x[0]
        let filterBooks = x[1].map(y => [y[0], bookIds[source][y[0]], source])
        // console.log(source, filterBooks.length, bookIds[source])
        return acc.concat(filterBooks)
      }, [])
      // console.log(tmp, state.allBooksId)
      TimSort.sort(tmp, IdCompare)
      // console.log(tmp, state.allBooksId)
      Vue.set(state, 'validBooks', tmp)
    } else {
      if (state.validBooks.length !== state.allBooksId.length) {
        // console.log('validBooks is all')
        Vue.set(state, 'validBooks', state.allBooksId)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/collections.js